function etsInstaIsPreviewMode(){
  var url = new URL(window.location.href);
  var previewMode = url.searchParams.get('etsMMPreviewMode');
  if(previewMode)
  {
    return true;
  }
  return false
}
var ETS_MM_CONFIG = {
  navigator: etsInstaIsPreviewMode() ? "309173649539-child-084b5374f3b6c43b3cd8be9e2a74aea1-legacy-shoes" : "309173649539-child-084b5374f3b6c43b3cd8be9e2a74aea1-legacy-shoes",
  use_embeddedcode: etsInstaIsPreviewMode() ? 0 : 0,
  show_class_mobile: etsInstaIsPreviewMode() ? 0 : 0,
  menu_enabled: etsInstaIsPreviewMode() ? 1 : 0
};
